import { useState } from "react";
import { MailCheck, Loader2, RefreshCw, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function VerifyPrompt() {
  const { user, logout, refresh } = useAuth();
  const [busy, setBusy] = useState(false);

  const resend = async () => {
    setBusy(true);
    try { await api.post("/auth/resend-verification"); toast.success("Verification email sent — check your inbox."); }
    catch { toast.error("Could not resend. Please try again."); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4" data-testid="verify-prompt">
      <div className="max-w-md w-full bg-white rounded-2xl border border-slate-200 p-8 text-center">
        <div className="mx-auto h-14 w-14 rounded-2xl bg-blue-500 flex items-center justify-center"><MailCheck className="h-7 w-7 text-white" /></div>
        <h1 className="font-heading text-2xl font-bold mt-4 text-slate-900">Verify your email</h1>
        <p className="text-slate-500 mt-2">We've sent a verification link to <span className="font-semibold text-slate-700">{user?.email}</span>. Please click it to activate your account and continue setup.</p>
        <div className="mt-6 space-y-2">
          <Button data-testid="resend-verification" onClick={resend} disabled={busy} className="w-full bg-blue-600 hover:bg-blue-700 gap-2">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <RefreshCw className="h-4 w-4" />} Resend verification email
          </Button>
          <Button data-testid="verify-refresh" onClick={refresh} variant="outline" className="w-full">I've verified — refresh</Button>
          <button data-testid="verify-logout" onClick={logout} className="text-sm text-slate-400 hover:text-slate-600 flex items-center gap-1 mx-auto mt-2"><LogOut className="h-3.5 w-3.5" /> Sign out</button>
        </div>
      </div>
    </div>
  );
}
